/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class AssessmentRoute extends Route {
  queryParams = {
    moduleId: {
      refreshModel: false,
    },
  };

  // Services
  @service
  store;

  model(params) {
    let group = this.modelFor('group');
    return hash({
      group,
      learners: this.modelFor('group.insights').learners,
      assessment: this.store.findRecord(
        'assessments/assessment',
        params.assessment_id,
      ),
      modules: this.store.query('assessments/module', {
        assessmentId: params.assessment_id,
        include: 'gradeSchedules',
      }),
      grades: this.store.query('assessments/grade', {
        assessmentId: params.assessment_id,
        groupId: group.id,
        latest: true,
      }),
    });
  }

  afterModel(model) {
    super.afterModel(...arguments);
    this.controllerFor('group/insights/assessments').set(
      'assessmentId',
      model.assessment.id,
    );
  }
}
